import React, { useRef, useState } from "react";
import { makeStyles } from "@mui/styles";
import { ClickAwayListener, MenuList, MenuItem as MaterialMenuItem, Popper, Paper, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "./styles";
import clsx from "clsx";

const Dropdown = (props) => {
  const { options, onSelect, hoverEnable = true, downIcon = true, currentSelectedMenu="" ,placeHolder = "Select Option" ,selectedMenuLabelClass} = props;
  const classes = makeStyles(styles)();
  const menuIconRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(currentSelectedMenu);

  const handleMenuSelect = (option, e) => {
    e.stopPropagation();
    setOpen(false);
    setSelectedMenu(option.label);
    onSelect(option);
  };
  const handleMenuClose = () => {
    setOpen(false);
  };

  const handleMouseClick = (e) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleMouseEnter = (e) => {
    if (hoverEnable) {
      e.stopPropagation();
      setOpen(true);
    }
  };

  const handleMouseLeave = (e) => {
    if (hoverEnable) {
      e.stopPropagation();
      setOpen(false);
    }
  };

  return (
    <ClickAwayListener onClickAway={handleMenuClose}>
      <div onMouseLeave={handleMouseLeave} onClick={handleMouseClick} className={classes.root}>
        <div className={clsx(classes.menuItem)} ref={menuIconRef} onMouseEnter={handleMouseEnter} onClick={handleMouseEnter}>
          <Typography className={clsx(classes.label, selectedMenuLabelClass)}>{selectedMenu || placeHolder}</Typography>
          {downIcon ? <ExpandMoreIcon className={classes.downIcon} /> : null}
        </div>

        {options && options.length ? (
          <Popper open={open} anchorEl={menuIconRef.current} onClose={handleMenuClose} style={{zIndex:2}} placement="bottom-start" disablePortal>
            <Paper>
              <MenuList>
                {options.map((option) => {
                  return (
                    <MaterialMenuItem className={classes.subMenuItem} key={option.value} onClick={(e) => handleMenuSelect(option, e)}>
                      {option.label}
                    </MaterialMenuItem>
                  );
                })}
              </MenuList>
            </Paper>
          </Popper>
        ) : null}
      </div>
    </ClickAwayListener>
  );
};

export default Dropdown;
